import { CellRenderer, Rectangle, styleUtils } from "@maxgraph/core";
import { CustomCellState } from "../models/diagram.models";

/**
 * Renderizador customizado de células.
 */
export class CustomCellRenderer extends CellRenderer {

    override createControl(state: CustomCellState) {
        super.createControl(state);

        if (state.cell.isEdge()) {
            if (!state.deleteControl && state.cell.customBuildCallback) {
                state.cell.customBuildCallback(state);
            }
        } else if (state.deleteControl != null) {
            state.deleteControl.destroy();
            state.deleteControl = null;
        }
    }

    override redraw(state: CustomCellState, force: boolean = false, rendering: boolean = false): void {
        if (state.cell.setCustomStyle) {
            state.cell.setCustomStyle(state);
        }

        super.redraw(state, force, rendering);
    }

    override redrawControl(state: CustomCellState) {
        super.redrawControl(state);

        if (state.deleteControl != null) {
            const bounds = this.getDeleteControlBounds(state);
            const scale = state.view.scale;

            if (state.deleteControl.scale !== scale || !state.deleteControl.bounds.equals(bounds)) {
                state.deleteControl.bounds = bounds;
                state.deleteControl.scale = scale;
                state.deleteControl.redraw();
            }
        }
    }

    override destroy(state: CustomCellState) {
        super.destroy(state);

        if (state.deleteControl != null) {
            state.deleteControl.destroy();
            state.deleteControl = null;
        }
    }

    /**
     * Responsável por recalcular a posição de um elemento de controle de uma célula.
     * Atualmente é utilizado apenas para os botões de remoção dos links DWDM.
     *
     * @param state - CustomCellState da celula que contém o elemento de controle.
     * @returns Retângulo com as novas coordenadas do controle.
     */
    private getDeleteControlBounds(state: CustomCellState) : Rectangle {
        if (state.deleteControl != null) {
            const oldScale = state.deleteControl.scale;

            const w = state.deleteControl.bounds.width  / oldScale;
            const h = state.deleteControl.bounds.height / oldScale;
            const s = state.view.scale;

            const labelSizing = styleUtils.getSizeForString(this.getLabelValue(state) || "")

            const labelWidth  = labelSizing.width  * s;
            const labelHeight = labelSizing.height * s;

            const newX = state.x + (state.width  / 2) + (labelWidth / 2) + ((w / 2) * s);
            const newY = state.y + (state.height / 2) - labelHeight      - ((h / 2) * s);

            return state.cell.isEdge()
                ? new Rectangle(newX, newY, w * s, h * s)
                : new Rectangle(state.x + state.width - w * s, state.y, w * s, h * s);
        }

        return null;
    }
}
